<template>
  <Header headerShadow="header__area header__padding header__shadow" />
  <section class="page__title-area pt-90 pb-90">
    <div class="page__title-shape">
      <img class="page-title-shape-5 d-sm-block" src="../assets/img/page-title/page-title-shape-1.png" alt="">
      <img class="page-title-shape-6" src="../assets/img/page-title/page-title-shape-6.png" alt="">
      <img class="page-title-shape-7" src="../assets/img/page-title/page-title-shape-4.png" alt="">
    </div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="course__wrapper">
            <div class="page__title-content pt-90 mb-25">
              <div class="page__title-breadcrumb">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item"><router-link to="/">{{ $t('actions.home') }}</router-link></li>
                    <li class="breadcrumb-item active" aria-current="page">{{ $t('actions.fotoGalerea') }}</li>
                  </ol>
                </nav>
              </div>
              <h5 class="page__title-3" style="font-size: 35px">{{ $t('actions.fotoGalerea') }}</h5>
            </div>

            <div class="course__tab-content">
              <div class="tab-content" id="courseTabContent">
                <div class="tab-pane fade show active mb-30" id="description" role="tabpanel" aria-labelledby="description-tab">
                  <div class="course__description px-0 row">
                    <div v-for="(vm,index) in fotos" :key="index" class="col-4 mb-4">
                      <div style="cursor: pointer" @click="showImage(vm.image)">
                        <img class="circle__image" :src="baseUrl+vm.image" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="float-end">
              <b-pagination v-model="params.page" :total-rows="fotos.totalItems" :per-page="fotos.size"></b-pagination>
            </div> -->
          </div>
        </div>
      </div>
      <div>
        <div>
          <b-modal v-model="showModal" size="xl" centered>
            <img style="width:100%; height: 80vh; cursor: pointer; object-fit: cover; border:1px solid rgba(128,128,128,0.25)" :src="baseUrl+selectImage" alt="">
          </b-modal>
        </div>
      </div>
    </div>
  </section>
  <!-- Footer -->
  <Footer footerPadding="true"/>
</template>

<script>
import Header from '../components/HomeTwo/Header.vue';
import Footer from '../components/Home/Footer.vue';
import CourseItemMixin from '../mixins/courseItemsMixin';
// import CourseSidebar from '../components/CourseDetails/CourseSidebar.vue';
import {Swiper, SwiperSlide} from "swiper/vue";
import { Pagination } from "swiper";
import { mapGetters, mapActions } from 'vuex'
import BlogMixin from '@/mixins/blogMixin';


export default {
  name: "CourseDetailsPage",
  components:{
    Swiper,
    SwiperSlide,
    Header,
    // CourseSidebar,
    Footer
  },
  mixins: [CourseItemMixin, BlogMixin],
  data() {
    return {
      showModal:false,
      selectImage:'',
      params:{
        page: 1,
        size:9
      },
    }
  },
  watch:{
    'params.page':{
      handler(){
        this.getFotos(this.params);      }
    }
  },
  created() {
    this.getFotos(this.params);
  },
  computed:{
    ...mapGetters('fotos', ["fotos"])
  },
  methods: {
    ...mapActions('fotos', ["getFotos"]),
    showImage(vm){
      this.showModal = true;
      this.selectImage = vm;
    }
  }
};
</script>

<style scoped lang="css">
.course__description{
  width: 100%;
  padding: 20px 15px;
  border-radius: 8px;
}
.circle__image {
  width: 330px;
  height: 330px;
  object-fit: cover;
  object-position: center;
  border: 1px solid rgba(128, 128, 128, 0.1);
  box-shadow: 0 0 0 0 rgba(255,255,255, 0.4);
  padding: 10px;
  border-radius: 3px;
}

</style>
